import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpApiService } from '@recruitee/http';

import { CurrentUserPreferencesRequestData } from './current-user-preferences.types';

@Injectable({ providedIn: 'root' })
export class CurrentUserPreferencesHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public loadCurrentUserPreferences(): Observable<any> {
    return this.httpApi.get('/admin/preferences', null, { skipCompany: true });
  }

  public updateCurrentUserPreferences(data: Partial<CurrentUserPreferencesRequestData>) {
    return this.httpApi.patch('/admin/preferences', {}, data, { skipCompany: true });
  }
}
